export const safeReadJsonFromLocalStorage = (key, fallback = null) => {
  if (typeof window === "undefined" || !key) return fallback;

  try {
    const rawValue = window.localStorage.getItem(key);
    if (!rawValue) return fallback;
    const parsed = JSON.parse(rawValue);
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
};

export const safeReadFirstJsonFromLocalStorage = (
  keys,
  fallback = null
) => {
  if (!Array.isArray(keys)) return fallback;

  for (const key of keys) {
    const parsed = safeReadJsonFromLocalStorage(key, undefined);
    if (parsed !== undefined && parsed !== null) {
      return parsed;
    }
  }

  return fallback;
};
